import {
    BaseError,
} from 'wanderu-utils';

export class StructuredEventError extends BaseError {}
